import { defineStore } from "pinia";
import DataSource from "devextreme/data/data_source";
import { ref } from "vue";
import { useHirarkiListModel } from "@/stores/models/hirarki-list-model";

export const useHirarkiListStore = defineStore("hirarkiListStore", () => {
  const isLoading = ref(false);
  const dataSourceHirarkiList = ref(
    new DataSource({
      requireTotalCount: true,
      store: useHirarkiListModel().hirarkiListCustomStore,
      filter: null,
      skip: 0,
      take: null,
    }),
  );

  const dataSourceHirarkiListGetData = ref(
    new DataSource({
      requireTotalCount: true,
      store: useHirarkiListModel().hirarkiListCustomStore,
      filter: null,
      skip: 0,
      take: null,
    }),
  );

  // const dataSourcePegawaiList = (additionalParams = null) => {
  //     console.log('masuk dataSourcePegawaiList', additionalParams)
  //     return new DataSource({
  //       requireTotalCount: true,
  //       load: (loadOptions) => {
  //         // Handle load options and additionalParams separately
  //         return usePegawaiListModel().pegawaiListCustomStore.load([loadOptions, additionalParams]);
  //       }
  //     });
  // };

  const getData = async (filter) => {
    const allowedFields = [
      "jabatan_id",
      "cabang_id",
      "bagian_id",
      "bidang_id",
      "sub_bagian_id",
      "sub_bidang_id",
      "unit_id",
      "seksi_id",
    ];

    // If filter is an array of [key, '=', value]
    const filtered = Array.isArray(filter)
      ? filter.filter(([key]) => allowedFields.includes(key))
      : [];

    useHirarkiListModel().setFilter(filtered);

    useHirarkiListModel().setTake("all");
    await dataSourceHirarkiListGetData.value.reload();
    // await  dataSourceDukList.value.reload();
    let result = {
      data: dataSourceHirarkiListGetData.value._items,
      totalCount: dataSourceHirarkiListGetData.value._items.length,
      // summary: [totalBiaya]
    };

    // return {
    //   data: dataSourceHirarkiListGetData.value._items,
    //   totalCount: dataSourceHirarkiListGetData.value._items.length,
    //   // summary: [totalBiaya]
    // };
    useHirarkiListModel().setFilter(null);
    return result;

    //  return dataSourceDiklatList.value._items;
  };

  const setFilter = (filter) => {
    useHirarkiListModel().setFilter(filter);
    dataSourceHirarkiList.value.reload();
  };

  const state = ref(true);
  const refresh = () => {
    dataSourceHirarkiList.value.reload();
  };

  const onTglChanged = (e) => {
    const tgl = e.value; // You get the selected date here
    useHirarkiListModel().setFilter(["tgl", "=", tgl]);
    dataSourceHirarkiList.value.reload();
  };

  const onPegawaiStatusChanged = (e) => {
    useHirarkiListModel().setFilter(["capeg_tetap", "=", e.value]);
    dataSourceHirarkiList.value.reload();
  };

  const initialized = () => {
    // const currentDate = new Date();
    // const currentYear = currentDate.getFullYear();
    // const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
    // const formattedDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-01`;
    useHirarkiListModel().setFilter(null);
    dataSourceHirarkiList.value.reload();
  };

  return {
    setFilter,
    onPegawaiStatusChanged,
    dataSourceHirarkiList,
    isLoading,
    refresh,
    initialized,
    state,
    getData,
    onTglChanged,
  };
});
